<template>
    <div class="container my-2" id="telaPrincipal">
        <div v-if="mensagemSucesso">
            <div v-for="i in mensagemSucesso" :key="i">
                <b-alert show variant="success" dismissible>
                    <b-icon variant="success" icon="check" />
                    {{ i }}
                </b-alert>
            </div>
        </div>

        <div v-if="mensagemErro">
            <div v-for="i in mensagemErro" :key="i">
                <b-alert show variant="danger" dismissible>
                    <b-icon variant="danger" icon="x-circle-fill" />
                    {{ i }}
                </b-alert>
            </div>
        </div>

        <div style="text-align: center">
            <loading :active.sync="carregando" :is-full-page="true"></loading>
        </div>

        <form @submit.prevent>
            <h2 class="title mt-5">EMISSÃO DE DRAM E CDAP</h2>
            <b-card>

                <b-row class="my-3 mb-2">
                    <b-col sm="2" class="mt-2">CARTÓRIO</b-col>
                    <b-col sm="8" md="8">
                        <b-form-select
                            id="cartorio"
                            v-model="idCartorio"
                            :options="opcoesCartorios"
                            :disabled="!permissaoAcessoeEspecial"
                        >
                        </b-form-select>
                    </b-col>
                </b-row>

                 <!-- <b-row class="mt-3 mb-2">
                      <b-col sm="2" md="2">Cartório</b-col>
                      <b-col sm="8" md="8">{{nomeCartorio}}</b-col>
                 </b-row>    -->
                 <b-row class="mt-4 mb-5">
                    <b-col sm="2" md="2">Tipo emissão</b-col>
                    <b-col sm="8" md="8">
                        <b-form-radio-group v-model="tipoEmissao" 
                                            :options="tipoEmissaoOptions"
                                            stacked
                                            class="radio-espacado"
                            required></b-form-radio-group>
                    </b-col>
                </b-row>
                
                <b-row class="mb-3">
                    <b-col sm="2" align-self="end">
                        <label for="numeroProtocolo">Número do Protocolo</label>
                    </b-col>
                    <b-col sm="3" align-self="start">
                        <b-form-input id="numeroProtocolo"
                                      v-mask="['##########']" 
                                      v-model="numeroProtocolo">
                        </b-form-input>
                    </b-col>
                </b-row>

                <!-- <b-row class="mb-3">
                    <b-col sm="2" align-self="end">
                        <label for="senhaCartorio">Senha Cartório</label>
                    </b-col>
                    <b-col sm="3" align-self="start">
                        <b-form-input id="senhaCartorio" v-model="senhaCartorio" type="password">
                        </b-form-input>
                    </b-col>
                </b-row> -->

                <b-row class="float-right">
                    <b-col sm="6">
                        <b-button variant="primary" :disabled="desabilitarBotaoEmitir"
                            @click="pesquisar">Pesquisar</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </form>

    </div>
</template>

<script>
import { mask } from "vue-the-mask";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import normalizaMensagemApi from '../helpers/normalizaMensagemApi';
import constantes from "../constants/index";

export default {
    components: {
        loading,
    },
    directives: {
        mask,
    },
    data() {
        return {
            permissaoAcessoeEspecial: false,
            origemAcesso: "",
            opcoesCartorios: [],            
            carregando: false,
            mensagemSucesso: [],
            mensagemErro: [],
            numeroProtocolo: "",
            senhaCartorio: "",
            idCartorio: "",
            tipoEmissao: "1",
            nomeCartorio: "", 
            tipoEmissaoOptions: [
                { value: "1", text: "DRAM ( Documento de Recolhimento e Arrecadação Municipal )" },
                { value: "2", text: "CDAP ( Certidão de Dívida Ativa e Protestos )" },
            ],
        };
    },
    computed: {
        desabilitarBotaoEmitir() {
            return (!this.numeroProtocolo || !this.nomeCartorio ) && !this.idCartorio;
        },
    },
    async beforeMount() {
        this.userName = this.$store.getters.userInfo.preferred_username;
        this.origemAcesso = this.$store.getters.userInfo.origem;

        try {
            this.mensagemSucesso = [];
            this.mensagemErro = [];                
            this.carregando = true;           
            /// verifica se o usuario tem permissão especial para acessar todos cartorios /// 
            if (this.origemAcesso == "AD") {
                await this.$axios
                    .post(this.$env.url_backend + constantes.possuiPermissaoEspecial, {
                        usecase: 'USC.21.112',                        
                        usuario: this.userName.toUpperCase(),           
                    })
                    .then((response) => {
                    this.permissaoAcessoeEspecial  = response.data;
                    })
                    .catch((error) => {
                        this.permissaoAcessoeEspecial = false;
                        const mensagem = normalizaMensagemApi(error);   
                        this.mensagemErro.push(mensagem);                 
                    });         
            }
            ///  carrega cartorios ///   
            this.$axios
            .get(`${this.$env.url_backend}/v1/cartorios/listaCartorios`)
            .then((response) => {
                const options = response.data;
                for (let i = 0, l = options.length; i < l; i++) {
                this.opcoesCartorios.push({
                    text: options[i].NOME,
                    value: options[i].ID_CARTORIO,
            
                    hidden: false,
                });
                }

                this.opcoesCartorios.unshift({
                text: "SELECIONE",
                value: "",
                selected: true,
                disabled: true,
                hidden: true,
                });
            })
            .catch(() => {
                this.mensagemErro.push("Erro ao se conectar com o servidor.");
                window.scrollTo(0, 0);
            });
            ///
            if (!this.permissaoAcessoeEspecial){   //// NÃO tem permissao 
                const response = await this.$axios.post(`${this.$env.url_backend}/v1/cartorios`, {
                    numeroProtocolo: this.numeroProtocolo,
                    pusuario: this.userName
                });

               this.idCartorio = response.data.VALOR;
               this.nomeCartorio = response.data.NOME;
             }
        } catch (error) {
            const mensagem = normalizaMensagemApi(error);
            console.log({ error })
            this.mensagemErro.push(mensagem)
        } finally {
            this.carregando = false;
        }        
    },
    created() {
      
    },

    watch: {

    },

    methods: {
        async pesquisar() {
            try {
                this.mensagemSucesso = [];
                this.mensagemErro = [];                
                this.carregando = true;

                await this.$axios
                    .get(`${this.$env.url_backend}/v1/cartorios/protocolo?numeroProtocolo=${this.numeroProtocolo}&idCartorio=${this.idCartorio}`)
                    .then(response => {
                        const existeProtocolo = response.data.numeroProtocoloExiste;
                        if (existeProtocolo) this.emitir();
                    })
                    .catch((error) => {
                        const mensagem = normalizaMensagemApi(error);
                        this.mensagemErro.push(mensagem);
                    }).finally(() => {
                        this.carregando = false;
                    }); 

            } catch (error) {
                const mensagem = normalizaMensagemApi(error);
                console.log({ error })
                this.mensagemErro.push(mensagem)
            } finally {
                this.carregando = false;
            }
        },

        async emitir() {
            this.carregando = true;
            this.mensagemSucesso = [];
            this.mensagemErro = [];

            switch (this.tipoEmissao) {
                case "1":
                    await this.$axios
                        .get(`${this.$env.url_backend}/v1/cartorios/guia?numeroProtocolo=${this.numeroProtocolo}&idCartorio=${this.idCartorio}`)
                        .then(response => {
                            this.mensagemSucesso.push("Guia emitida com sucesso");
                            let url = response.data.url;
                            
                            window.open(url, "_blank");
                        })
                        .catch((error) => {
                            const mensagem = normalizaMensagemApi(error);
                            this.mensagemErro.push(mensagem);
                        }).finally(() => {
                            this.carregando = false;
                        });
                    break;
                case "2":                   
                    await this.$axios
                        .get(`${this.$env.url_backend}/v1/cartorios/certidao?numeroProtocolo=${this.numeroProtocolo}&idCartorio=${this.idCartorio}`, { responseType: "arraybuffer" })
                        .then(response => {
                            this.mensagemSucesso.push("Certidão emitida com sucesso");

                            const pdfBlob = new Blob([response.data], { type: "application/pdf" })

                            const blobUrl = window.URL.createObjectURL(pdfBlob)
                            const link = document.createElement('a')
                            link.href = blobUrl
                            link.setAttribute('download', `certidao-${this.numeroProtocolo}.pdf`)
                            link.click();
                            link.remove();
                            URL.revokeObjectURL(blobUrl);
                        })
                        .catch((error) => {
                            const mensagem = normalizaMensagemApi(error);
                            console.log({ mensagem })
                            this.mensagemErro.push(mensagem);
                        }).finally(() => {
                            this.carregando = false;
                        });
                    break;
                default:
                    this.carregando = false;
                    this.mensagemErro.push("Tipo de emissão inválido");
                    break;
            }
        },
    },

}

</script>


<style>
    .radio-espacado .custom-control {
    margin-bottom: 10px;
    }

    .radio-espacado .custom-control:last-child {
    margin-bottom: 0;
    }
</style>
